import React from "react";
import Header from "../components/Header";
import Hero from "../components/Hero";
import Stats from "../components/Stats";
import HowItWorks from "../components/HowItWorks";
import Calculator from "../components/Calculator";
import CostTrends from "../components/CostTrends";
import AIFeatures from "../components/AIFeatures";
import RenderStudio from "../components/RenderStudio";
import Pricing from "../components/Pricing";
import BuildTypes from "../components/BuildTypes";
import Testimonials from "../components/Testimonials";
import CTA from "../components/CTA";
import Footer from "../components/Footer";

const Landing = () => {
  return (
    <div className="bg-white">
      <Header />
      <main>
        <Hero />
        <Stats />
        <HowItWorks />
        <Calculator />
        <CostTrends />
        <AIFeatures />
        <RenderStudio />
        <Pricing />
        <BuildTypes />
        <Testimonials />
        <CTA />
      </main>
      <Footer />
    </div>
  );
};

export default Landing;
